import { __assign } from "tslib";
import { LOG_IN, REFRESH_TRACKER_SESSION, LOADING, ACCESS_TOKEN, TOGGLE_DRAWER, FETCH_LOAN, FETCH_LOAN_PAYMENT_SUPPLEMENT, FETCH_LOANS, SELECT_LOAN, FETCH_DOCUMENTS, UPDATE_MESSAGE_CENTER, UPDATE_LOAN_PREF, LOAN_ACTIVITY, PENNYWISE, UI_DATA, FAQS, GET_MESSAGES, CUSTOMER_OBJECT_MODEL, DOC_TEMPLATES, LOAN_NUMBERS, FEATURE_TOGGLES, CLOSED_END_SECONDS, RESET_STATE, FILTER_LOAN_ACTIVITY, TRANSACTION_TYPE, POP_UPS, TRANSACTION_CODES, CHANGE_LANGUAGE, EASY_SET_LOAN, OFFLINE_MODE, OFFLINE_MODE_DETACH, E_DIS, EDIS_EL, FETCH_LASTPAYMNETRECEIVEDDATE, IDS_USER_PROFILE, SET_TOKEN, MOD_TEMPLATES, FETCH_MODIFICATION, CHAT_MESSAGES, SHOW_CHAT, CHAT_MINIMIZED, CHAT_SESSION_DATA, MAIN_DISPATCH, CHAT_SPEAKER_IS_ON, CHAT_IS_SPEAKING, CHAT_MIC_IS_ON, CHAT_IS_BLOCKED, PAYMENT_VALIDATION, CLIENT_API_ROUTE, LOG_OUT, UPDATE_TITLE, APP_SETTINGS, REFRESHING, BILL_MATRIX, LIVE_AGENT_JOINED, TRANSFER_TO_AGENT, AGENT_SESSION_TOKEN, SAVE_WATSON_LATEST_MSG, HIPPO_DATA, SIMPLYIOA_DATA, NACHA_BANKACCOUNT, OFFERS, ASK_ENABLE_BIO, GET_ESCROW_ANALYSIS_LOOKBACK, ESCROW_ANALYSIS_AVAILABLE, BIO_WORKING, UPDATE_DEXP_MESSAGE_ENTRY, DELETE_DEXP_MESSAGE_ENTRY, CREATE_DEXP_MESSAGE_ENTRY, REVIEWS, PUSH_NOTIFICATION_ASKED, FETCH_BORROWER_CONTACT_RULES, USER_IDLE_TIMEOUT, TAX_OPTIONS_AVAILABLE, UPDATE_BOTTOM_TAB_ICON_COLOR } from '../actions/actions.js';
import _ from 'underscore';
import moment from 'moment';
import { decryptBankAccountNumber, encryptBankAccountNumber, getLogoUrl, isCobranded, isPennymac, isPrivateLabel } from '../../utils';
function generateRandomBigInt(lowBigInt, highBigInt) {
  if (lowBigInt >= highBigInt) {
    throw new Error('lowBigInt must be smaller than highBigInt');
  }
  var difference = highBigInt - lowBigInt;
  var differenceLength = difference.toString().length;
  var multiplier = '';
  while (multiplier.length < differenceLength) {
    multiplier += Math.random().toString().split('.')[1];
  }
  multiplier = multiplier.slice(0, differenceLength);
  var divisor = '1' + '0'.repeat(differenceLength);
  var randomDifference = difference * parseInt(multiplier) / parseInt(divisor);
  return parseInt(lowBigInt + randomDifference);
}
var intitialState = {
  logoUrl: getLogoUrl(),
  isPennymac: isPennymac(),
  isCobranded: isCobranded(),
  isPrivateLabel: isPrivateLabel(),
  messages: [],
  logedIn: false,
  loading: false,
  loadingEscrowUI: false,
  reloadingData: false,
  token: "",
  uiData: null,
  language: "en",
  pennyWise: false,
  drawerOpen: false,
  borrowerId: null,
  mobile: false,
  appSettings: {},
  title: "My Penny Home",
  route: "",
  loanNumbers: [{
    loanId: 0,
    propertyStreet: ""
  }],
  currentLoan: null,
  paymentSupplement: [],
  loanArray: [],
  documents: null,
  loginPressed: false,
  customerPreference: null,
  customerPreferences: null,
  trackerSession: generateRandomBigInt(100000000000000000, 999999999999999999),
  currentLoanActivity: null,
  loanActivityArray: [],
  selectedLoanNumber: 0,
  faqs: null,
  baseRoute: "/",
  customerObjectModel: {},
  pennyHomeUrl: "/",
  movr_url: "",
  features: [],
  isEligible: null,
  lastPaymentReceivedDate: null,
  passage: "",
  statusHistories: [],
  logedInState: "",
  selectedLoanAvailability: null,
  whitelisted: false,
  loanNumberWithCommas: "",
  popups: [],
  chatMessages: null,
  proposalEvent: undefined,
  modLoaded: false,
  bioWorking: false,
  isAutoLogin: false,
  DEXPMessagePennyContentKey: "",
  userProfile: {
    auth_client_app: "",
    auth_client_at: null,
    auth_client_at_formatted: null,
    customer_id: "",
    first_name: null,
    flavor: "",
    google_authenticator: {
      qr_url: "",
      token: ""
    },
    ip_address: "",
    is_active: false,
    jornaya_id: "",
    last_four_ssn: "",
    last_name: null,
    loan_numbers: "",
    login_count: 9,
    login_on: "",
    phone_number_tcpa: false,
    previous_login_on: "",
    security_questions_answers: [],
    length: 3,
    selected_tfa_type: "",
    tcpa_timestamp: "",
    updated_on: "",
    user_id: "",
    username: "",
    verified_email: "",
    verified_email_previous: "",
    verified_phone_number: null,
    transactionTypes: []
  },
  banksToAdd: [],
  changeLanguageFunction: function () {
    return null;
  },
  modTemplates: null,
  modications: null,
  showChat: false,
  chatIsBlocked: false,
  chatWindowMinimized: false,
  chatSessionId: null,
  userChatSessionId: 0,
  paymentModel: null,
  modPortalVisible: false,
  blend_url: null,
  borrowerLoans: null,
  chatToggles: null,
  paymentInfo: false,
  wrapedMobile: false,
  billMatrix: null,
  liveAgentName: null,
  transferToLiveAgent: false,
  startAgentParams: null,
  lastWatsonMessage: null,
  hippoData: null,
  pennyHomeFullyQualified: null,
  nachaBanksToAdd: [],
  localTime: null,
  segmentData: [],
  segmentId: null,
  offers: [],
  chatIsInitialized: false,
  escrowAnalysisLookBackData: [],
  borrowerContactRules: [],
  lender_details: [],
  translationsText: {
    'es': {},
    'en': {}
  },
  translations: {},
  buydownSubsidy: {},
  showComunicationPreferenceChangeBanner: false,
  isUserIdle: false,
  taxOptionAvailable: false,
  selectedViewForBottomTab: null
};
var layout = function (state, action) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37;
  state = state || intitialState;
  switch (action.type) {
    case RESET_STATE:
      state.paymentModel = null;
      return __assign({}, state);
    case REVIEWS:
      return __assign(__assign({}, state), {
        reviews: action.reviews
      });
    case BIO_WORKING:
      return __assign(__assign({}, state), {
        bioWorking: action.working,
        isAutoLogin: action.autoLogin
      });
    case ESCROW_ANALYSIS_AVAILABLE:
      return __assign(__assign({}, state), {
        isEscrowAnalysisEnabled: action.isEscrowAnalysisEnabled
      });
    case PUSH_NOTIFICATION_ASKED:
      return __assign(__assign({}, state), {
        pushEnabledAsked: true
      });
    case ASK_ENABLE_BIO:
      return __assign(__assign({}, state), {
        isEnabledBioAsked: true
      });
    case CLOSED_END_SECONDS:
      {
        return __assign(__assign({}, state), {
          closedEndSeconds: action.payment
        });
      }
    case HIPPO_DATA:
      return __assign(__assign({}, state), {
        hippoData: action.hippoData
      });
    case EASY_SET_LOAN:
      return __assign(__assign({}, state), {
        selectedLoanNumber: action.loanId
      });
    case SIMPLYIOA_DATA:
      return __assign(__assign({}, state), {
        simplyIOAData: action.simplyIOAData
      });
    case BILL_MATRIX:
      return __assign(__assign({}, state), {
        billMatrix: action.billMatrix
      });
    case APP_SETTINGS:
      return __assign(__assign({}, state), {
        appSettings: __assign(__assign({}, state.appSettings), action.appSettings)
      });
    case E_DIS:
      var banksToAdd = (_a = action === null || action === void 0 ? void 0 : action.banksToAdd.map(function (bank) {
        return __assign(__assign({}, bank), {
          unmaskedAccountNumber: decryptBankAccountNumber(bank.unmaskedAccountNumberEncode)
        });
      })) !== null && _a !== void 0 ? _a : [];
      return __assign(__assign({}, state), {
        banksToAdd: banksToAdd
      });
    case OFFLINE_MODE:
      return __assign(__assign({}, state), {
        proposalEvent: (_b = action === null || action === void 0 ? void 0 : action.event) === null || _b === void 0 ? void 0 : _b.proposalEvent
      });
    case OFFLINE_MODE_DETACH:
      return __assign(__assign({}, state), {
        proposalEvent: undefined
      });
    case CHANGE_LANGUAGE:
      if (!action.dontPost) {
        var t = ((_c = state === null || state === void 0 ? void 0 : state.customerPreference) === null || _c === void 0 ? void 0 : _c.forEach(function (s) {
          s.loanId = state.selectedLoanNumber;
          if (action.lang == "en" && s.prefenceTypeId == 300097) {
            s.prefenceValueTypeId = 300099;
          } else if (s.prefenceTypeId == 300097) {
            s.prefenceValueTypeId = 300100;
          }
        })) || [];
        var sendNotification = action.sendNotification === undefined || action.sendNotification === null ? true : action.sendNotification;
        if ((state === null || state === void 0 ? void 0 : state.customerPreference) && (state === null || state === void 0 ? void 0 : state.customerPreference.length) > 0) {
          fetch("".concat(state.pennyHomeUrl, "api/account/update_customer_preferences?sendNotification=").concat(sendNotification), {
            method: 'POST',
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              "Authorization": "Bearer ".concat(state.token)
            },
            body: JSON.stringify(state === null || state === void 0 ? void 0 : state.customerPreference)
          }).then(function (res) {
            return res.json();
          }).then(function (data) {
            console.log("Date Request", data);
          });
        }
      }
      return __assign(__assign({}, state), {
        language: action.lang,
        translations: state.translationsText[action.lang || 'en']
      });
    case UPDATE_TITLE:
      return __assign(__assign({}, state), {
        title: action.title,
        route: action.route
      });
    case POP_UPS:
      return __assign(__assign({}, state), {
        popups: action.popups
      });
    case LOG_IN:
      return __assign(__assign({}, state), {
        logedIn: action.logedIn,
        logedInState: "loggedOut",
        loginPressed: action.loginPressed,
        isusernamechanged: false,
        selectedLoanNumber: state.mobile ? 0 : state.selectedLoanNumber
      });
    case REFRESH_TRACKER_SESSION:
      return __assign(__assign({}, state), {
        trackerSession: generateRandomBigInt(100000000000000000, 999999999999999999)
      });
    case LOADING:
      return __assign(__assign({}, state), {
        loading: action.act
      });
    case FEATURE_TOGGLES:
      var f = action.features;
      var chatFeature = (_d = action.features) === null || _d === void 0 ? void 0 : _d.find(function (a) {
        return a.feature == "MacChat";
      });
      var chatToggles = null;
      if (chatFeature) {
        var chatFeatureDesc = chatFeature.description;
        try {
          chatToggles = JSON.parse(chatFeatureDesc);
        } catch (e) {
          chatToggles = null;
        }
      }
      return __assign(__assign({}, state), {
        features: action.features,
        chatToggles: chatToggles
      });
    case IDS_USER_PROFILE:
      return __assign(__assign({}, state), {
        userProfile: action.userProfile
      });
    case ACCESS_TOKEN:
      var isValid = /^[0-9,]*$/.test(action.loanNumbers);
      var bId = action.index_borrower_id ? action.index_borrower_id : action.borrowerId;
      return __assign(__assign({}, state), {
        lender_details: ((_e = action.lender_details) === null || _e === void 0 ? void 0 : _e.split(",")) || [],
        token: action.token || state.token,
        state_id: action.state_id,
        index_borrower_id: bId,
        selectedLoanNumber: state.selectedLoanNumber > 0 ? state.selectedLoanNumber : (_h = (_g = (_f = action.loanNumbers) === null || _f === void 0 ? void 0 : _f.split(",")) === null || _g === void 0 ? void 0 : _g[0]) !== null && _h !== void 0 ? _h : 0,
        logedIn: action.logedIn,
        logedInState: "loggedIn",
        userProfile: action.userProfile,
        loanNumbers: isValid ? ((_j = action.loanNumbers) === null || _j === void 0 ? void 0 : _j.split(",").map(function (s) {
          return {
            loanId: parseInt(s),
            propertyStreet: ""
          };
        })) || [{
          loanId: 0,
          propertyStreet: ""
        }] : state.loanNumbers,
        baseRoute: "".concat(action.url, "/"),
        borrowerId: bId,
        movr_url: action.movr_url,
        vapid: action.vapid,
        mobile: state.mobile ? state.mobile : action.mobile || false,
        pennyHomeUrl: action.pennyHomeUrl ? action.pennyHomeUrl : state.pennyHomeUrl,
        liveAgentUrl: action.live_agent_url,
        liveAgentFlowId: action.live_agent_flow,
        blend_url: action.blend_url,
        liveAgentInstanceId: action.live_agent_instance,
        pennyHomeFullyQualified: action.penny_home_url,
        localTime: action.server_time,
        mdm_id: action.mdm_id,
        showComunicationPreferenceChangeBanner: (action === null || action === void 0 ? void 0 : action.showComunicationPreferenceChangeBanner) || false,
        segmentData: (_k = action.segments) === null || _k === void 0 ? void 0 : _k.split("-").map(function (s) {
          return {
            loanId: parseInt(s.split("_")[0]),
            segmentId: parseInt(s.split("_")[1])
          };
        })
      });
    case SET_TOKEN:
      return __assign(__assign({}, state), {
        token: action.token || state.token,
        wrapedMobile: action.mobileWraped,
        selectedLoanNumber: action.selectedLoanNumber || state.selectedLoanNumber
      });
    case TOGGLE_DRAWER:
      return __assign(__assign({}, state), {
        drawerOpen: !state.drawerOpen
      });
    case FETCH_LOAN:
      return __assign(__assign({}, state), {
        currentLoan: action.jsData
      });
    case FETCH_LOAN_PAYMENT_SUPPLEMENT:
      return __assign(__assign({}, state), {
        paymentSupplement: action.data
      });
    case "LOAN_ID_0":
      return __assign(__assign({}, state), {
        selectedLoanNumber: 0
      });
    case FETCH_LOANS:
      var loan_1 = null;
      var currentLoanId_1;
      var borrowerId_1;
      currentLoanId_1 = parseInt(state.selectedLoanNumber);
      if (currentLoanId_1 > 0 && !isNaN(currentLoanId_1)) {
        loan_1 = (_l = action.jsData) === null || _l === void 0 ? void 0 : _l.loanSummary.find(function (a) {
          return a.loanId == currentLoanId_1;
        });
      }
      if (parseInt(loan_1 === null || loan_1 === void 0 ? void 0 : loan_1.loanId) > 0 && !state.pennyWise) {
        fetch("".concat(state.pennyHomeUrl, "api/loan/switch_loans"), {
          method: 'POST',
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": "Bearer ".concat(state.token)
          },
          body: JSON.stringify({
            loanId: loan_1 === null || loan_1 === void 0 ? void 0 : loan_1.loanId
          })
        });
      }
      var currentLoan_1 = ((_m = action.jsData) === null || _m === void 0 ? void 0 : _m.loanSummary) ? loan_1 : null;
      var borrowerLoans = (_o = action.jsData) === null || _o === void 0 ? void 0 : _o.borrowerLoans;
      var buydownSubsidy = (_q = (_p = action.jsData) === null || _p === void 0 ? void 0 : _p.buydownSubsidy) !== null && _q !== void 0 ? _q : {};
      var servicingContractTypeId = (_r = currentLoan_1 === null || currentLoan_1 === void 0 ? void 0 : currentLoan_1.organizationServicerSummary) === null || _r === void 0 ? void 0 : _r.servicingContractTypeId;
      var logoUrl = getLogoUrl(currentLoan_1.organizationServicerSummary.organizationLogoFilePath, (_s = currentLoan_1 === null || currentLoan_1 === void 0 ? void 0 : currentLoan_1.organizationServicerSummary) === null || _s === void 0 ? void 0 : _s.msrCode, servicingContractTypeId);
      if (borrowerLoans && currentLoan_1 && borrowerLoans.length > 0) {
        borrowerId_1 = (_t = borrowerLoans.find(function (w) {
          return w.loanId == currentLoan_1.loanId;
        })) === null || _t === void 0 ? void 0 : _t.borrowerId;
      }
      if (borrowerId_1 === undefined || borrowerId_1 === null || borrowerId_1 === "0" || borrowerId_1 === 0) {
        borrowerId_1 = currentLoan_1 === null || currentLoan_1 === void 0 ? void 0 : currentLoan_1.borrowerSummary[0].borrowerId;
      }
      var lang = "en";
      var customerPreference = null;
      if (borrowerId_1) {
        if ((_u = action.jsData) === null || _u === void 0 ? void 0 : _u.customerPreferences) {
          customerPreference = _.where((_v = action.jsData) === null || _v === void 0 ? void 0 : _v.customerPreferences, {
            borrowerId: borrowerId_1
          });
        }
        lang = ((_y = (_x = (_w = action.jsData) === null || _w === void 0 ? void 0 : _w.customerPreferences) === null || _x === void 0 ? void 0 : _x.find(function (s) {
          return s.borrowerId == borrowerId_1 && s.prefenceTypeId == 300097;
        })) === null || _y === void 0 ? void 0 : _y.prefenceValueTypeId) == 300100 ? "es" : "en";
      }
      return __assign(__assign({}, state), {
        servicerId: ((_z = currentLoan_1 === null || currentLoan_1 === void 0 ? void 0 : currentLoan_1.organizationServicerSummary) === null || _z === void 0 ? void 0 : _z.msrCode) || '001',
        MSRId: ((_0 = currentLoan_1 === null || currentLoan_1 === void 0 ? void 0 : currentLoan_1.organizationServicerSummary) === null || _0 === void 0 ? void 0 : _0.msrCode) || '001',
        loanArray: ((_1 = action.jsData) === null || _1 === void 0 ? void 0 : _1.loanSummary) || [],
        currentLoan: currentLoan_1 ? currentLoan_1 : {},
        selectedLoanNumber: ((_2 = action.jsData) === null || _2 === void 0 ? void 0 : _2.loanSummary) ? loan_1 === null || loan_1 === void 0 ? void 0 : loan_1.loanId : 0,
        statusHistories: ((_3 = action.jsData) === null || _3 === void 0 ? void 0 : _3.loanStatusHistory) || {},
        selectedLoanAvailability: (_4 = action.jsData) === null || _4 === void 0 ? void 0 : _4.loanStatusHistory.find(function (s) {
          return s.loanId == (loan_1 === null || loan_1 === void 0 ? void 0 : loan_1.loanId);
        }),
        passage: ((_5 = action.jsData) === null || _5 === void 0 ? void 0 : _5.loanStatusHistory.find(function (s) {
          return s.loanId == (loan_1 === null || loan_1 === void 0 ? void 0 : loan_1.loanId);
        })) ? (_6 = action.jsData) === null || _6 === void 0 ? void 0 : _6.loanStatusHistory.find(function (s) {
          return s.loanId == (loan_1 === null || loan_1 === void 0 ? void 0 : loan_1.loanId);
        }).passage : "",
        yearEndData: ((_8 = (_7 = action.jsData) === null || _7 === void 0 ? void 0 : _7.yearEndTaxAndInterestData) === null || _8 === void 0 ? void 0 : _8.find(function (s) {
          return s.loanId === (loan_1 === null || loan_1 === void 0 ? void 0 : loan_1.loanId);
        })) || {},
        allYearEndData: (_9 = action.jsData) === null || _9 === void 0 ? void 0 : _9.yearEndTaxAndInterestData,
        loanPreference: (_10 = action.jsData) === null || _10 === void 0 ? void 0 : _10.loanPreference,
        selectedLoanPreference: (_12 = (_11 = action.jsData) === null || _11 === void 0 ? void 0 : _11.loanPreference) === null || _12 === void 0 ? void 0 : _12.filter(function (s) {
          return s.loanId === (loan_1 === null || loan_1 === void 0 ? void 0 : loan_1.loanId);
        }),
        customerPreferences: (_13 = action.jsData) === null || _13 === void 0 ? void 0 : _13.customerPreferences,
        customerPreference: customerPreference,
        whitelisted: action.jsData.whiteList,
        language: lang,
        borrowerId: borrowerId_1 ? borrowerId_1 : state.borrowerId,
        borrowerLoans: borrowerLoans,
        segmentId: ((_15 = (_14 = state.segmentData) === null || _14 === void 0 ? void 0 : _14.find(function (s) {
          return s.loanId == (loan_1 === null || loan_1 === void 0 ? void 0 : loan_1.loanId);
        })) === null || _15 === void 0 ? void 0 : _15.segmentId) || 0,
        buydownSubsidy: buydownSubsidy,
        logoUrl: logoUrl,
        isPennymac: isPennymac(servicingContractTypeId),
        isCobranded: isCobranded(servicingContractTypeId),
        isPrivateLabel: isPrivateLabel(servicingContractTypeId)
      });
    case SELECT_LOAN:
      if (parseInt(action === null || action === void 0 ? void 0 : action.loanId) > 0) {
        fetch("/api/loan/switch_loans", {
          method: 'POST',
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": "Bearer ".concat(state.token)
          },
          body: JSON.stringify({
            loanId: action === null || action === void 0 ? void 0 : action.loanId
          })
        });
      }
      currentLoan_1 = state.loanArray.find(function (s) {
        return s.loanId === parseInt(action.loanId);
      });
      if (state.borrowerLoans && currentLoan_1 && state.borrowerLoans.length > 0) {
        borrowerId_1 = (_16 = state.borrowerLoans.find(function (w) {
          return w.loanId == currentLoan_1.loanId;
        })) === null || _16 === void 0 ? void 0 : _16.borrowerId;
      }
      var customerPreference = null;
      lang = "en";
      if (borrowerId_1) {
        if (state.customerPreferences) {
          customerPreference = _.where(state.customerPreferences, {
            borrowerId: borrowerId_1
          });
        }
        lang = ((_18 = (_17 = state.customerPreferences) === null || _17 === void 0 ? void 0 : _17.find(function (s) {
          return s.borrowerId == borrowerId_1 && s.prefenceTypeId == 300097;
        })) === null || _18 === void 0 ? void 0 : _18.prefenceValueTypeId) == 300100 ? "es" : "en";
      }
      return __assign(__assign({}, state), {
        servicerId: ((_19 = currentLoan_1 === null || currentLoan_1 === void 0 ? void 0 : currentLoan_1.organizationServicerSummary) === null || _19 === void 0 ? void 0 : _19.msrCode) || '001',
        MSRId: ((_20 = currentLoan_1 === null || currentLoan_1 === void 0 ? void 0 : currentLoan_1.organizationServicerSummary) === null || _20 === void 0 ? void 0 : _20.msrCode) || '001',
        selectedLoanNumber: parseInt(action.loanId),
        currentLoan: currentLoan_1,
        currentLoanActivity: state.loanActivityArray.find(function (s) {
          return s.loanId === parseInt(action.loanId);
        }),
        selectedLoanAvailability: state.statusHistories.find(function (s) {
          return s.loanId === parseInt(action.loanId);
        }),
        yearEndData: state.allYearEndData.find(function (s) {
          return s.loanId === parseInt(action.loanId);
        }) || {},
        passage: state.statusHistories.find(function (s) {
          return s.loanId === parseInt(action.loanId);
        }) ? state.statusHistories.find(function (s) {
          return s.loanId === parseInt(action.loanId);
        }).passage : "",
        selectedLoanPreference: state.loanPreference.filter(function (s) {
          return s.loanId === action.loanId;
        }),
        documents: null,
        selectedLoanMessages: (_21 = state.messages) === null || _21 === void 0 ? void 0 : _21.filter(function (s) {
          return s.loanId == action.loanId;
        }),
        customerPreference: customerPreference,
        language: lang,
        borrowerId: borrowerId_1,
        paymentModel: null,
        segmentId: ((_23 = (_22 = state.segmentData) === null || _22 === void 0 ? void 0 : _22.find(function (s) {
          return s.loanId == parseInt(action.loanId);
        })) === null || _23 === void 0 ? void 0 : _23.segmentId) || 0
      });
    case EDIS_EL:
      return __assign(__assign({}, state), {
        isEligible: action.dis
      });
    case FETCH_LASTPAYMNETRECEIVEDDATE:
      return __assign(__assign({}, state), {
        lastPaymentReceivedDate: action.PaymentReceivedDate
      });
    case FETCH_DOCUMENTS:
      return __assign(__assign({}, state), {
        documents: action.jsDataDocs
      });
    case UPDATE_MESSAGE_CENTER:
      return __assign(__assign({}, state), {
        customerPreference: action.customerPreference
      });
    case UPDATE_LOAN_PREF:
      return __assign(__assign({}, state), {
        selectedLoanPreference: action.selectedLoanPreference
      });
    case LOAN_ACTIVITY:
      return __assign(__assign({}, state), {
        loanActivityArray: action.loanActivity,
        currentLoanActivity: action.loanActivity.find(function (s) {
          return s.loanId === state.selectedLoanNumber;
        })
      });
    case FILTER_LOAN_ACTIVITY:
      return __assign(__assign({}, state), {
        currentLoanActivity: action.loanActivity
      });
    case PENNYWISE:
      return __assign(__assign({}, state), {
        pennyWise: action.is,
        token: action.token,
        loanNumberWithCommas: action.loanId,
        selectedLoanNumber: (_25 = (_24 = action.loanId) === null || _24 === void 0 ? void 0 : _24.split(',')) === null || _25 === void 0 ? void 0 : _25[0],
        loanNumbers: ((_26 = action.loanId) === null || _26 === void 0 ? void 0 : _26.split(",").map(function (s) {
          return {
            loanId: parseInt(s),
            propertyStreet: ""
          };
        })) || [{
          loanId: 0,
          propertyStreet: ""
        }],
        pennyHomeUrl: action.url,
        logedIn: true,
        logedInState: "loggedIn"
      });
    case UI_DATA:
      var translations = state.translationsText;
      for (var i = 0; i < ((_27 = action === null || action === void 0 ? void 0 : action.uiData) === null || _27 === void 0 ? void 0 : _27.length); i++) {
        var pennyContentDetails = (_28 = action === null || action === void 0 ? void 0 : action.uiData[i]) === null || _28 === void 0 ? void 0 : _28.pennyContentDetails;
        if (pennyContentDetails) {
          for (var j = 0; j < (pennyContentDetails === null || pennyContentDetails === void 0 ? void 0 : pennyContentDetails.length); j++) {
            translations.es[pennyContentDetails[j].reference] = (_29 = pennyContentDetails[j]) === null || _29 === void 0 ? void 0 : _29.es;
            translations.en[pennyContentDetails[j].reference] = (_30 = pennyContentDetails[j]) === null || _30 === void 0 ? void 0 : _30.en;
          }
        }
      }
      var newTranslations = {
        es: __assign(__assign({}, state.translations['es']), translations['es']),
        en: __assign(__assign({}, state.translations['en']), translations['en'])
      };
      return __assign(__assign({}, state), {
        uiData: action.uiData,
        logedIn: action.logedIn ? action.logedIn : state.logedIn,
        translationsText: translations,
        translations: __assign({}, newTranslations[state.language])
      });
    case FAQS:
      return __assign(__assign({}, state), {
        faqs: action.faqs
      });
    case SHOW_CHAT:
      return __assign(__assign({}, state), {
        showChat: action.showChat
      });
    case CHAT_MINIMIZED:
      return __assign(__assign({}, state), {
        chatWindowMinimized: action.chatWindowMinimized
      });
    case CHAT_SESSION_DATA:
      return __assign(__assign({}, state), {
        chatSessionId: action.chatSessionId,
        userChatSessionId: action.userChatSessionId,
        chatReadyToResume: action.chatReadyToResume || false
      });
    case CHAT_SPEAKER_IS_ON:
      return __assign(__assign({}, state), {
        pennyCanTalk: action.pennyCanTalk
      });
    case CHAT_IS_SPEAKING:
      return __assign(__assign({}, state), {
        isSpeaking: action.isSpeaking
      });
    case CHAT_MIC_IS_ON:
      return __assign(__assign({}, state), {
        pennyCanHear: action.pennyCanHear
      });
    case CHAT_IS_BLOCKED:
      return __assign(__assign({}, state), {
        chatIsBlocked: action.chatIsBlocked
      });
    case CHAT_MESSAGES:
      return __assign(__assign({}, state), {
        chatMessages: action.messages,
        chatIsInitialized: true
      });
    case GET_MESSAGES:
      return __assign(__assign({}, state), {
        messages: (_31 = action.messages) === null || _31 === void 0 ? void 0 : _31.filter(function (s) {
          return s.subjectLID != 3000001;
        }),
        selectedLoanMessages: action.messages.filter(function (s) {
          return s.loanId == state.selectedLoanNumber && s.subjectLID != 3000001;
        })
      });
    case CUSTOMER_OBJECT_MODEL:
      return __assign(__assign({}, state), {
        customerObjectModel: action.customerObjectModel || state.customerObjectModel
      });
    case DOC_TEMPLATES:
      return __assign(__assign({}, state), {
        docTemplates: action.docTemplates
      });
    case LOAN_NUMBERS:
      return __assign(__assign({}, state), {
        loanNumbers: ((_32 = action.loanNumbers) === null || _32 === void 0 ? void 0 : _32.split(",").map(function (s) {
          return {
            loanId: parseInt(s),
            propertyStreet: ""
          };
        })) || [{
          loanId: 0,
          propertyStreet: ""
        }],
        token: action.token || state.token
      });
    case TRANSACTION_TYPE:
      return __assign(__assign({}, state), {
        transactionTypes: action.transactionTypes
      });
    case TRANSACTION_CODES:
      return __assign(__assign({}, state), {
        transactionCodes: action.transactionCodes
      });
    case MOD_TEMPLATES:
      return __assign(__assign({}, state), {
        modTemplates: action.modTemplates
      });
    case FETCH_MODIFICATION:
      var mod = action.modifications;
      var modVisible = false;
      if (mod && mod.statusTypeId && mod.isModPortalVisible) {
        modVisible = true;
      }
      return __assign(__assign({}, state), {
        modifications: mod,
        modPortalVisible: modVisible,
        modLoaded: true
      });
    case MAIN_DISPATCH:
      var sta = __assign(__assign({}, action.state), state);
      return sta;
    case PAYMENT_VALIDATION:
      var distinct_1 = [];
      /**Adding default payments * /
      //**To be deleted start * /
      let defPayments = {
          "defaultPaymentsDue": [{
              "paymentAmountDue": 80000.0,
              "paymentDueDate": "2023-09-01T00:00:00",
              "isPaymentRequired": false,
              "defaultPaymentType": 1
              }, {
              "paymentAmountDue": 80000.0,
              "paymentDueDate": "2023-10-01T00:00:00",
              "isPaymentRequired": false,
              "defaultPaymentType": 2
              }, {
              "paymentAmountDue": 80000.0,
              "paymentDueDate": "2023-11-01T00:00:00",
              "isPaymentRequired": false,
              "defaultPaymentType": 2
              }],
          "minTotalPaymentAmountDue": 160000.0,
          "minRequiredNumberOfPITIPayments": 2,
          "programName": "FNMA Flex Full Doc Modification",
          "planStartDate": "2023 -12-01T00:00:00Z",
          "planEndDate": "2024-02-29T00:00:00Z",
          "maxPaymentEffectiveDate": "2024-03-08T00:00:00",
          "route": "Default",
          "allowOTD": true,
         // "ruleId":"Suspended_Forbearance"
         //"ruleId":"Increased_Payment_Plan"
            "ruleId":"Decreased_Payment_Plan"
      }
      action.payment.loan.defaultPayments = defPayments
      action.payment.loan.isLoanInForbearance =  true;
      //**To be deleted end */
      var pa = (action === null || action === void 0 ? void 0 : action.payment) || {};
      if (Object.keys(pa).length > 0) {
        pa.pendingPayments.forEach(function (s) {
          var inthere = distinct_1.find(function (e) {
            return moment(e.effectiveDate).format("MM/DD/YYYY") == moment(s.effectiveDate).format("MM/DD/YYYY") && s.aymentType == e.draftSource && s.paymentType != 201309;
          });
          if (inthere) {
            if (moment(inthere.effectiveDate).isBefore(moment(s.effectiveDate))) {
              var inthere_1 = distinct_1.findIndex(function (e) {
                return moment(e.effectiveDate).format("MM/DD/YYYY") == moment(s.effectiveDate).format("MM/DD/YYYY");
              });
              distinct_1.splice(inthere_1, 1);
              distinct_1.push(s);
            }
          } else {
            distinct_1.push(s);
          }
        });
      }
      pa.pendingPayments = distinct_1;
      var paymentModel = __assign(__assign({}, pa), {
        bankAccounts: (_34 = (_33 = pa.bankAccounts) === null || _33 === void 0 ? void 0 : _33.map(function (bank) {
          return __assign(__assign({}, bank), {
            unmaskedAccountNumber: decryptBankAccountNumber(bank.unmaskedAccountNumberEncode)
          });
        })) !== null && _34 !== void 0 ? _34 : [],
        payment: __assign(__assign({}, pa.payment), {
          bankAccount: pa.payment.bankAccount && __assign(__assign({}, pa.payment.bankAccount), {
            unmaskedAccountNumber: decryptBankAccountNumber(pa.payment.bankAccount.unmaskedAccountNumberEncode)
          })
        }),
        pendingPayments: (_36 = (_35 = pa.pendingPayments) === null || _35 === void 0 ? void 0 : _35.map(function (payment) {
          return __assign(__assign({}, payment), {
            bankAccount: payment.bankAccount && __assign(__assign({}, payment.bankAccount), {
              unmaskedAccountNumber: decryptBankAccountNumber(payment.bankAccount.unmaskedAccountNumberEncode)
            })
          });
        })) !== null && _36 !== void 0 ? _36 : []
      });
      return __assign(__assign({}, state), {
        paymentModel: paymentModel,
        currentLoan: __assign(__assign({}, state.currentLoan), (_37 = action === null || action === void 0 ? void 0 : action.payment) === null || _37 === void 0 ? void 0 : _37.loan),
        paymentInfo: action.paymentInfo || false
      });
    case CLIENT_API_ROUTE:
      return __assign(__assign({}, state), {
        pennyHomeUrl: action.url
      });
    case LOG_OUT:
      return __assign(__assign({}, intitialState), {
        uiData: state.uiData,
        logedIn: action.logedIn,
        translationsText: state.translationsText,
        translations: state.translations
      });
    case REFRESHING:
      return __assign(__assign({}, state), {
        reloadingData: action.loading
      });
    case LIVE_AGENT_JOINED:
      return __assign(__assign({}, state), {
        liveAgentName: action.liveAgentName
      });
    case TRANSFER_TO_AGENT:
      return __assign(__assign({}, state), {
        transferToLiveAgent: action.transferToLiveAgent,
        startAgentParams: action.transferToLiveAgent ? state.startAgentParams : null
      });
    case AGENT_SESSION_TOKEN:
      return __assign(__assign({}, state), {
        startAgentParams: action.startAgentParams
      });
    case SAVE_WATSON_LATEST_MSG:
      return __assign(__assign({}, state), {
        lastWatsonMessage: action.lastWatsonMessage
      });
    case NACHA_BANKACCOUNT:
      return __assign(__assign({}, state), {
        paymentModel: action === null || action === void 0 ? void 0 : action.paymentModel
      });
    case OFFERS:
      return __assign(__assign({}, state), {
        offers: action.offers
      });
    case GET_ESCROW_ANALYSIS_LOOKBACK:
      return __assign(__assign({}, state), {
        escrowAnalysisLookBackData: action.escrowAnalysisLookBackData,
        loadingEscrowUI: action.loading
      });
    case UPDATE_DEXP_MESSAGE_ENTRY:
      return __assign(__assign({}, state), {
        DEXPMessagePennyContentKey: action.pennyContentKey
      });
    case DELETE_DEXP_MESSAGE_ENTRY:
      return __assign(__assign({}, state), {
        DEXPMessagePennyContentKey: ""
      });
    case CREATE_DEXP_MESSAGE_ENTRY:
      return __assign(__assign({}, state), {
        DEXPMessagePennyContentKey: action.pennyContentKey
      });
    case FETCH_BORROWER_CONTACT_RULES:
      return __assign(__assign({}, state), {
        borrowerContactRules: action.borrowerContactRules
      });
    case USER_IDLE_TIMEOUT:
      return __assign(__assign({}, state), {
        isUserIdle: action.value
      });
    case TAX_OPTIONS_AVAILABLE:
      return __assign(__assign({}, state), {
        taxOptionAvailable: action.taxOptionAvailable
      });
    case UPDATE_BOTTOM_TAB_ICON_COLOR:
      return __assign(__assign({}, state), {
        selectedViewForBottomTab: action.selectedViewForBottomTab
      });
    default:
      return __assign(__assign({}, intitialState), state);
  }
};
export default layout;